import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import { reportMarkdownComponents } from '#client/components/utils/markdownComponents';

/**
 * Convert JSON content to a readable markdown string
 * @param {object} obj - JSON object to convert
 * @returns {string} - Formatted markdown string
 */
const formatJsonToMarkdown = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .map((item) => {
        if (typeof item === 'object') {
          return formatJsonToMarkdown(item);
        }
        return `- ${item}`;
      })
      .join('\n');
  }

  return Object.entries(obj)
    .map(([key, value]) => {
      const formattedKey = key
        .replace(/_/g, ' ')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();

      if (typeof value === 'object' && value !== null) {
        return `**${formattedKey}:**\n${formatJsonToMarkdown(value)}`;
      }
      return `**${formattedKey}:** ${value}`;
    })
    .join('\n\n');
};

/**
 * Renders markdown content with optional JSON-to-markdown conversion
 * @param {object} props - Component props
 * @param {string|object} props.content - Content to render (string or JSON object)
 * @param {string} [props.viewType='default'] - View type for markdown components
 */
function MarkdownContent({ content, viewType = 'default' }) {
  // Convert content to string if it's an object
  const formattedContent =
    typeof content === 'object' && content !== null ? formatJsonToMarkdown(content) : content;

  return (
    <ReactMarkdown components={reportMarkdownComponents} viewType={viewType}>
      {formattedContent}
    </ReactMarkdown>
  );
}

MarkdownContent.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  viewType: PropTypes.oneOf(['default', 'report'])
};

export default MarkdownContent;
